<template>
    <div class="service-carry">
        <mt-header fixed title="客服工单执行">
            <router-link to="/my/phone_order" slot="left">
                <mt-button icon="back">返回</mt-button>
            </router-link>
        </mt-header>
        <div class="elder-form">
            <div class="service-order-block">
                <div class="service-order-header">
                    <div class="service-order-elder">工单对象：{{ service.elder }}</div><span class="service-status">待服务</span>
                </div>
                <div class="service-block-body">
                    <div class="service-order">
                        <div class="service-order-info">
                            <div class="service-order-tip">致电时间：{{ service.phone_time }}</div>
                            <div class="service-order-tip">工单内容：{{ service.ps }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mint-checklist">
                <label class="mint-checklist-title">执行照片</label>
                <uploader @getFiles='getImageList' @removeFiles='removeImage'></uploader>
            </div>
            <div class="elder-form-input">
                <mt-field label="执行备注" v-model="ps" type="textarea"></mt-field>
            </div>

            <div class="new-form-button">
                <mt-button size="large" type="primary" @click="serviceCarry()">提交</mt-button>
            </div>
        </div>
    </div>
</template>
<script>

    import uploader from "../../components/upload"
    import GlOBAL from "@/api/global"

    export default{

        components: {
            uploader
        },
        data(){
           return {
               service:{
                   product_image:[]
               },
               openid:JSON.parse(window.localStorage.getItem('UserInfo')).openid,
               phone_order_id:this.$route.params.id,
               ps:'',
               imgUrl:GlOBAL.imgUrl,
               imgList: [], //已上传的图片集合
           }
        },

        created(){
            this.$axios.get('/my/phoneOrderCarry?openid='+this.openid+'&phone_order_id='+this.phone_order_id)
                .then(data => {

                    if (data.data.code === 'OK') {
                        this.service = data.data.data;
                    } else {
                        this.$toast(data.data.message);
                    }
                });
        },

        methods:{

            getImageList(files) {
                this.$nextTick(() => {
                    for (let i = 0, len = files.length; i < len; i++) {
                        this.imgList.push(files[i].src.split("base64,")[1]);
                        //上传图片
                        //   this._getFileCode({
                        //     Base64Str: files[i].src.split("base64,")[1],
                        //     AttachmentType: this.$enums.AttachmentType.Activity
                        //   });
                    }
                });
            },
            //删除图片
            removeImage(index) {
                this.imgList.splice(index, 1);
            },

            //上传图片获取fileCode (目前该方法没调用，供参考)
            _getFileCode(obj) {
                // Indicator.open(this.lang.dynamic_publishing);
                this.$http
                    .post(this.$profileApi.Shared_UploadImage, obj)
                    .then(data => {
                        if (data.Rstatus) {
                            this.FilecodeList.push(data.Rdata);
                        } else {
                            // Toast(this.lang.dynamic_upload_fail);
                        }
                    })
                    .catch(err => {
                        //   Toast(this.lang.dynamic.dynamic_net_error);
                    });
            },

            serviceCarry(){
                let that = this;

                this.$indicator.open('加载中');

                this.$axios.post("/my/phoneOrderCarry", {openid:this.openid,thumb:this.imgList,phone_order_id:this.phone_order_id,ps:this.ps})
                    .then(data => {

                        this.$indicator.close();

                        if (data.data.code === 'OK') {
                            this.$toast('服务执行成功！');
                            setTimeout(function(){
                                that.$router.push('/my/phone_order');
                            },2000);
                        } else {
                            this.$toast(data.data.message);
                        }
                    });
            }
        }
    }
</script>
<style scoped>
    .service-order-block{
        background:#fff;
    }

    .service-order-header{
        padding:10px 20px;
        border-bottom:1px solid #f4f4f4;
        font-size:12px;
        color:#848a8f;
        display:flex;
        justify-content: space-between;
    }

    .service-block-body{
        padding:15px;
    }


    .service-tips span{
        font-size:12px;
    }


    .service-order{
        display:flex;
    }

    .service-order-thumb img{
        width: 50px;
        height: 50px;
        padding: 5px;
        border: 1px solid #dedede;
    }

    .service-order-info{
        padding-left:15px;
    }

    .service-order-info .service-order-title{
        font-size:14px;
        padding: 4px 0;
    }

    .service-order-info .service-order-tip{
        font-size:12px;
        color: #848a8f;
    }

    .service-order-address{
        font-size:12px;
        color: #848a8f;
        padding-top:10px;
    }


    .elder-form-input{
        margin-top:10px;
    }

    .service-order-title span{
        color:#ffcb01;
        padding-left:5px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/my/phoneOrderCarry.vue